import React from 'react';
import cx from 'classnames';

import PageComposer from 'Components/PageComposer/PageComposer';
import Content from 'Storybook/local/Content/Content';
import { PAGE_SLUGS } from 'Utilities/consts';

import { ProductFooter } from '../ProductPageComponents/ProductFooter/ProductFooter';

import { BenefitsSection } from './BenefitsSection/BenefitsSection';
import { FAQSection } from './FAQSection/FAQSection';
import { HeroSection } from './HeroSection/HeroSection';
import { HowItWorks } from './HowItWorksSection/HowItWorks';
import { ModalJoinMotorwayPay } from './ModalJoinMotorwayPay/ModalJoinMotorwayPay';
import { ModalRequestCallback } from './ModalRequestCallback/ModalRequestCallback';
import { StockFundsSection } from './StockFundsSection/StockFundsSection';
import { StraplineSection } from './StraplineSection/StraplineSection';
import type { DiscoverMWPayProps } from './DiscoverMWPay.types';
import { useDiscoverMWPay } from './useDiscoverMWPay';

import styles from './DiscoverMWPay.module.scss';

// We divided out content out of `PageComposer` so we don't rendered entire page shell when eg. modal opens
// That's generally a good practice to avoid unnecessary re-renders.
// We could separate modals to individual components as well, but it's not a big deal in this case.
const DiscoverMWPayContent: React.FC<DiscoverMWPayProps> = (params) => {
	const {
		benefitsProps,
		faqProps,
		heroProps,
		joinModalProps,
		requestCallbackProps,
		showJoinModal,
		showRequestCallbackModal,
	} = useDiscoverMWPay(params);

	return (
		<>
			<Content
				data-use-scroll-margin
				className={styles.main}
				element="main"
				wrapper={{ className: cx(styles.wrapper, styles.theme) }}
				wrapperContentPre={<HeroSection {...heroProps} />}
			>
				<BenefitsSection {...benefitsProps} />
				<HowItWorks />
				<StockFundsSection />
				<StraplineSection />
				<FAQSection {...faqProps} />
			</Content>
			{showJoinModal && <ModalJoinMotorwayPay {...joinModalProps} />}
			{showRequestCallbackModal && <ModalRequestCallback {...requestCallbackProps} />}
			<ProductFooter
				actions={heroProps.actions}
				className={styles.theme}
				title={
					<>
						Join <strong>Motorway Pay</strong> today
					</>
				}
			/>
		</>
	);
};

const DiscoverMWPay: React.FC<DiscoverMWPayProps> = (params) => (
	<PageComposer showFixedBottomBar fixedBottomBarClassName={styles.fixedBottomBar} pageSlug={PAGE_SLUGS.MOTORWAY_PAY}>
		<DiscoverMWPayContent {...params} />
	</PageComposer>
);

export default DiscoverMWPay;
